/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { LoadingSection } from '@coursera/cds-core';

export const Loader = ({
  width,
  height,
  // enables using css prop via emotion
  className,
}: {
  width: string;
  height: string | undefined;
  className?: string;
}) => {
  return (
    // [fe-tech-debt] lmsinteg-2119: it looks like directly setting the inline style for width + height is needed otherwise some stuff breaks. should probably look at this again when the custom height setting is udpated.
    <div className={`widget-loader ${className}`} style={{ width, height }}>
      <LoadingSection label="Fetching data..." data-testid="widget-spinner" />
    </div>
  );
};
